(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curated-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('[data-section-id]');
    
    sections.forEach(function(sectionElement) {
      const sectionId = sectionElement.getAttribute('data-section-id');
      if (!sectionId) return;
      
      const carouselWrapper = sectionElement.querySelector('[data-carousel-wrapper="' + sectionId + '"]');
      const carouselTrack = sectionElement.querySelector('[data-carousel-track="' + sectionId + '"]');
      const prevButton = sectionElement.querySelector('[data-carousel-prev="' + sectionId + '"]');
      const nextButton = sectionElement.querySelector('[data-carousel-next="' + sectionId + '"]');
      
      if (!carouselWrapper || !carouselTrack) return;

    if (!carouselWrapper || !carouselTrack) return;

      const scrollAmount = 240;

      function updateButtons() {
        if (!prevButton || !nextButton) return;
        
        const { scrollLeft, scrollWidth, clientWidth } = carouselWrapper;
        
        prevButton.style.opacity = scrollLeft <= 0 ? '0.5' : '1';
        prevButton.style.pointerEvents = scrollLeft <= 0 ? 'none' : 'auto';
        
        nextButton.style.opacity = scrollLeft >= scrollWidth - clientWidth - 1 ? '0.5' : '1';
        nextButton.style.pointerEvents = scrollLeft >= scrollWidth - clientWidth - 1 ? 'none' : 'auto';
      }

      if (prevButton) {
        prevButton.addEventListener('click', function() {
          carouselWrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function() {
          carouselWrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }

      carouselWrapper.addEventListener('scroll', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            const recommendationGrid = this.querySelector('[grid-recommendation]');
            const section = this.closest('[data-section-type="product-slider"]');
            const slider = section?.querySelector('.productSlider');

            if (recommendations && recommendationGrid && section && recommendations.innerHTML.trim().length) {
              if (slider?.swiper) {
                slider.swiper.destroy(true, true);
              }

              recommendationGrid.innerHTML = recommendations.innerHTML;
              theme.collectionSlider(section);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storie-dal-radar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carouselWrapper = document.querySelector('[data-carousel-wrapper]');
    if (!carouselWrapper) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    carouselWrapper.addEventListener('mousedown', (e) => {
      isDown = true;
      carouselWrapper.style.cursor = 'grabbing';
      startX = e.pageX - carouselWrapper.offsetLeft;
      scrollLeft = carouselWrapper.scrollLeft;
    });

    carouselWrapper.addEventListener('mouseleave', () => {
      isDown = false;
      carouselWrapper.style.cursor = 'grab';
    });

    carouselWrapper.addEventListener('mouseup', () => {
      isDown = false;
      carouselWrapper.style.cursor = 'grab';
    });

    carouselWrapper.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carouselWrapper.offsetLeft;
      const walk = (x - startX) * 2;
      carouselWrapper.scrollLeft = scrollLeft - walk;
    });

    carouselWrapper.style.cursor = 'grab';
  })();

  } catch(e) { console.error(e); }
})();
})();
